import * as THREE from "three";
import Experience from "./Experience";

export default class RayCaster {
  constructor() {
    this.experience = new Experience();
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;

    // Start off-screen so nothing is hovered before the pointer moves
    this.mouse = new THREE.Vector2(10, 10);

    window.addEventListener("mousemove", (_event) => {
      this.handlePointerMove(_event.clientX, _event.clientY, _event.target);
    });
    // Pointer left the window: stop hovering whatever it was last over
    document.documentElement.addEventListener("mouseleave", () => {
      this.mouse.set(10, 10);
    });
    window.addEventListener("touchstart", (event) => {
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        this.handlePointerMove(touch.clientX, touch.clientY, event.target);
      }
    });
    this.setInstance();
  }

  handlePointerMove(clientX, clientY, target) {
    // Pointer is over HTML (a button, a panel), not the scene: aim off-screen
    if (target !== this.experience.canvas) {
      this.mouse.set(10, 10);
      return;
    }
    this.mouse.x = (clientX / this.sizes.width) * 2 - 1;
    this.mouse.y = -(clientY / this.sizes.height) * 2 + 1;
  }

  setInstance() {
    this.instance = new THREE.Raycaster();
    this.instance.setFromCamera(this.mouse, this.camera.instance);
  }

  update() {
    this.instance.setFromCamera(this.mouse, this.camera.instance);
  }
}
